// extracted by mini-css-extract-plugin
export default {"labels":"DialogChangeEmail_labels__urtvo"};